import React from 'react'
import './Choice.css'
import { Link } from 'react-router-dom'
const Comfort = () => {
  return (
    <section className="section about-section-four" style={{background:'#fdfdfd'}}>
    <div className="container">
      <div className="row">
        <div
          className="col-lg-5 wow fadeInDown"
          data-wow-delay="0.2s"
          style={{
            visibility: "visible",
            animationDelay: "0.2s",
            animationName: "fadeInDown"
          }}
        >
          <div className="section-header section-header-four mb-4">
            <h2 className="mb-2" style={{fontWeight:'700'}}>
              <span>Where comfort</span> meets elegance and every guest is treated
              like family.
            </h2>
            <p className="sub-title">
            In the realm of B2B travel agencies, YatriService stands as your unwavering ally. Our commitment to reliability and excellence makes us a name you can confidently rely on for all your travel needs. Trust in Yatri Service to be your steadfast partner, providing a seamless and trustworthy experience in the world of B2B travel.
            </p>
            
          </div>
          <div className="row">
            <div className="col-sm-6">
              <div className="mb-3">
                <h6 className="display-6">
                  <span className="counter animated fadeInDownBig">5000</span>+
                </h6>
                <p>Customers</p>
              </div>
            </div>
            <div className="col-sm-6">
              <div className="mb-3">
                <h6 className="display-6">
                  <span className="counter animated fadeInDownBig">70,000</span>+
                </h6>
                <p>Bookings</p>
              </div>
            </div>
            <div className="col-sm-6">
              <div className="mb-3">
                <h6 className="display-6">
                  <span className="counter animated fadeInDownBig">200</span>+
                </h6>
                <p>Travel Agent</p>
              </div>
            </div>
            <div className="col-sm-6">
              <div className="mb-3">
                <h6 className="display-6">
                  <span className="counter animated fadeInDownBig">50</span>+
                </h6>
                <p>Client Globally</p>
              </div>
            </div>
          </div>
          <div className="d-flex align-items-center flex-wrap gap-3 mb-0 mb-md-4 mb-lg-0">
            {/* <a
              href="add-flight.html"
              className="btn btn-dark d-inline-flex align-items-center"
            >
              <i className="isax isax-add-circle5 me-2" />
              Add Flights
            </a> */}
            <Link
              to="/contact"
              className="btn btn-primary d-inline-flex align-items-center"
            >
              <i className="isax isax-calendar-2 me-2" />
             Contact Us
            </Link>
            <div className="card border-0 mb-0">
              <div className="card-body d-flex align-items-center">
                <div className="avatar-list-stacked avatar-group-md me-2">
                  <span className="avatar avatar-rounded">
                    <img
                      className="border border-white"
                      src="https://dreamstour.dreamstechnologies.com/html/assets/img/users/user-01.jpg"
                      alt="img"
                    />
                  </span>
                  <span className="avatar avatar-rounded">
                    <img
                      className="border border-white"
                      src="https://dreamstour.dreamstechnologies.com/html/assets/img/users/user-04.jpg"
                      alt="img"
                    />
                  </span>
                  <span className="avatar avatar-rounded">
                    <img
                      className="border border-white"
                      src="https://dreamstour.dreamstechnologies.com/html/assets/img/users/user-06.jpg"
                      alt="img"
                    />
                  </span>
                </div>
                <div style={{fontSize:'12px'}}>
                  <div className="d-flex align-items-center fs-12">
                    <i className="ti ti-star-filled text-warning" />
                    <i className="ti ti-star-filled text-warning" />
                    <i className="ti ti-star-filled text-warning" />
                    <i className="ti ti-star-filled text-warning" />
                    <i className="ti ti-star-filled text-warning me-1" />
                    <p className="fs-14 text-gray-9">5.0</p>
                  </div>
                  <p className="fs-14">2K+ Reviews</p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          className="col-lg-7 d-flex ps-lg-0 wow zoomIn"
          data-wow-delay="0.2s"
          style={{
            visibility: "visible",
            animationDelay: "0.2s",
            animationName: "zoomIn"
          }}
        >
          <div className="flight-about d-lg-flex align-items-center flex-fill">
            <img src='/Images/asfasfasf.png' alt="img" />
            <div className="flight-bg">
              <img  src='/Images/zsfzsdfsd.png' alt="img" />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div className="flight-bg">
      <img
        src="https://dreamstour.dreamstechnologies.com/html/assets/img/bg/flight-bg-01.png"
        alt="img"
        className="flight-bg-01"
      />
      <img
        src="https://dreamstour.dreamstechnologies.com/html/assets/img/bg/flight-bg-02.png"
        alt="img"
        className="flight-bg-02"
      />
    </div>
  </section>
  
  )
}

export default Comfort